import * as types from './types'

export const updateOrders = (orders) => ({
  type: types.UPDATE_ORDERS,
  payload: orders,
})

export const updatePagination = (pagination) => ({
  type: types.UPDATE_PAGINATION,
  payload: pagination,
})

export const updateOrderStatus = (status) => ({
  type: types.UPDATE_ORDER_STATUS,
  payload: status,
})

export const toggleOrderStatusPopUp = () => ({
  type: types.TOGGLE_ORDER_STATUS_POPUP,
})
